import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=39c7767c&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports